/**
 * 好友申请收件箱：展示未处理申请，同意 / 拒绝。
 * 数据来自 OpenIM SDK，不落 Nexora 库。
 */
import { Button, Empty, Flex, List, Tag, Typography, message } from "antd";
import type { FriendApplication } from "../types";

type Props = {
  items: FriendApplication[];
  disabled?: boolean;
  onAccept: (fromUserID: string) => Promise<void>;
  onRefuse: (fromUserID: string) => Promise<void>;
};

export function FriendInbox({ items, disabled, onAccept, onRefuse }: Props) {
  // handleResult: 0=未处理 1=已同意 -1=已拒绝
  const pending = items.filter((a) => a.handleResult === 0);

  if (pending.length === 0) {
    return (
      <Empty
        description="暂无待处理好友申请"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  return (
    <List
      size="small"
      bordered
      dataSource={pending}
      header={
        <Flex justify="space-between">
          <Typography.Text strong>好友申请</Typography.Text>
          <Tag color="processing">{pending.length}</Tag>
        </Flex>
      }
      renderItem={(a) => (
        <List.Item
          actions={[
            <Button
              key="ok"
              type="link"
              disabled={disabled}
              onClick={() =>
                void onAccept(a.fromUserID)
                  .then(() => message.success("已同意"))
                  .catch((e: Error) => message.error(e.message))
              }
            >
              同意
            </Button>,
            <Button
              key="no"
              type="link"
              danger
              disabled={disabled}
              onClick={() =>
                void onRefuse(a.fromUserID)
                  .then(() => message.success("已拒绝"))
                  .catch((e: Error) => message.error(e.message))
              }
            >
              拒绝
            </Button>,
          ]}
        >
          <List.Item.Meta
            title={a.fromNickname || a.fromUserID}
            description={a.reqMsg || "请求添加你为好友"}
          />
        </List.Item>
      )}
    />
  );
}
